import { colors } from "../../../Styles";

export function StationLoading() {
  const animation = `
    @keyframes pulseOpacity {
      0% { opacity: 0.2; }
      25% { opacity: 1; }
      50% { opacity: 1; }
      75% { opacity: 1; }
      100% { opacity: 0.2; }
    }
  `
  return (<>
    <style>{animation}</style>
    <svg viewBox="0 0 118 37" height="37px" width="118px" fill={colors.greyTertiary}>
      <path style={{ animation: `pulseOpacity 1.5s ease-in-out infinite` }} d="M118 28.9754V3C118 1.34315 116.657 0 115 0H25.075H3C1.34315 0 0 1.34315 0 3V28.9928C0 30.6525 1.34751 31.9968 3.00715 31.9928L10.325 31.9754H115C116.657 31.9754 118 30.6322 118 28.9754Z"/>
    </svg>
  </>)
}